import Model from './Model'

export default class AddOn extends Model {

	/** @type string */ full_display_name
	/** @type boolean */ hide_on_order_sheet
	/** @type number */ price_value
	/** @type string */ selected_option

	constructor({ selected_option_choice, selected_option_choice_name, ...attrs }) {
		super(attrs)
		this.selected_option = selected_option_choice? selected_option_choice_name : null
	}
}
